import React, { Fragment, useState, useEffect, useRef } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import ReactSelect from "react-select";
import Cookies from "js-cookie";

const { config } = require("../api/api");

const OmanVisaForm = () => {
  const { t } = useTranslation();
  const lnstr = Cookies.get("langData") ? Cookies.get("langData") : "en";
  const [formData, setFormData] = useState({
    fullName: "",
    nationality: "",
    nationalityId: "",
    dateOfBirth: "",
    gender: "",
    passportNumber: "",
    passportIssueDate: "",
    passportExpiryDate: "",
    countryOfIssue: "",
    countryOfIssueId: "",
    placeOfIssue: "",
    email: "",
    originMobile: "",
    originMobileCode: "",
    omanMobileCode: "",
    omanMobile: "",
    entryDate: "",
    stayDuration: "",
    visaType: "",
  });
  const [errors, setErrors] = useState({
    fullName: "",
    nationality: "",
    nationalityId: "",
    dateOfBirth: "",
    gender: "",
    passportNumber: "",
    passportIssueDate: "",
    passportExpiryDate: "",
    countryOfIssue: "",
    countryOfIssueId: "",
    placeOfIssue: "",
    email: "",
    originMobile: "",
    originMobileCode: "",
    omanMobileCode: "",
    omanMobile: "",
    entryDate: "",
    stayDuration: "",
    visaType: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [vendorKey, setVendorKey] = useState("");
  const [countryList, setCountries] = useState([]);
  const [usrtok, setUsrtok] = useState("");
  const base_url = config.baseURL;

  const omanMobileCodeRef = useRef(null);
  const originMobileCodeRef = useRef(null);
  const nationalityRef = useRef(null);
  const countryOfIssueRef = useRef(null);
  const restrictedCountries = [
  "Pakistan",
  "Bangladesh",
  "Egypt",
  "Syria",
  "Afghanistan",
  "Sudan",
  "Lebanon",
];

  useEffect(() => {
    const storedUserString = Cookies.get("userData");
    if (storedUserString !== undefined) {
      const user_data = JSON.parse(storedUserString);

      setUsrtok(user_data.access_token);
    }
  }, []);

  useEffect(() => {
    try {
      const storedFormData = sessionStorage.getItem("omanVisaFormData");

      if (storedFormData) {
        setFormData(JSON.parse(storedFormData));
      }
    } catch (error) {
      console.error("Error loading form data:", error);
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    const trimValue = value.trimStart();
    if (name == "fullName") {
      if (/^[A-Za-z\s]*$/.test(value)) {
        setFormData({
          ...formData,
          [name]: trimValue,
        });
        setErrors((prev) => ({ ...prev, [name]: "" }));
      }

      return;
    } else if (name == "nationality") {
      const { country_id } = e.target;

      const getCountry = countryList.filter((item) => item.id === country_id);

      setFormData({
        ...formData,
        [name]: getCountry[0].country,
        nationalityId: country_id,
      });
      setErrors((prev) => ({ ...prev, [name]: "" }));

      return;
    } else if (name == "countryOfIssue") {
      const { country_id } = e.target;

      const getCountry = countryList.filter((item) => item.id === country_id);

      setFormData({
        ...formData,
        [name]: getCountry[0].country,
        countryOfIssueId: country_id,
      });
      setErrors((prev) => ({ ...prev, [name]: "" }));

      return;
    } else if (name == "omanMobile" || name == "originMobile") {
      if (/^[0-9\s]*$/.test(value)) {
        setFormData({
          ...formData,
          [name]: trimValue,
        });
        setErrors((prev) => ({ ...prev, [name]: "" }));
      }
      return;
    } else if (name == "passportNumber") {
      if (/^[A-Za-z0-9]*$/.test(value)) {
        setFormData({
          ...formData,
          [name]: trimValue,
        });
        setErrors((prev) => ({ ...prev, [name]: "" }));
      }
      return;
    } else {
      setFormData({
        ...formData,
        [name]: trimValue,
      });
      setErrors((prev) => ({ ...prev, [name]: "" }));
      return;
    }
  };

  const handleSelectBlur = (e) => {
    const { name, value } = e.target;
    debugger;
    const trimValue = value.trimStart();

    if (name == "nationality") {
      //   const {country_id} = e.target;
      const error_field_name = name.replace(/([A-Z])/g, " $1").toLowerCase();
      if (!formData.nationalityId) {
        setErrors((prev) => ({
          ...prev,
          [name]: error_field_name + " " + "is required",
        }));
        return;
      } else {
        setErrors((prev) => ({ ...prev, [name]: "" }));
        return;
      }
    }

    if (name == "countryOfIssue") {
      //   const {country_id} = e.target;
      const error_field_name = name.replace(/([A-Z])/g, " $1").toLowerCase();
      if (!formData.countryOfIssueId) {
        setErrors((prev) => ({
          ...prev,
          [name]: error_field_name + " is required",
        }));
        return;
      } else {
        setErrors((prev) => ({ ...prev, [name]: "" }));
        return;
      }
    }

    if (name == "omanMobileCode") {
      //   const {country_id} = e.target;
      const error_field_name = name.replace(/([A-Z])/g, " $1").toLowerCase();
      if (!formData.omanMobileCode) {
        setErrors((prev) => ({
          ...prev,
          [name]: error_field_name + " is required",
        }));
        return;
      } else {
        setErrors((prev) => ({ ...prev, [name]: "" }));
        return;
      }
    }
    if (name == "originMobileCode") {
      //   const {country_id} = e.target;
      const error_field_name = name.replace(/([A-Z])/g, " $1").toLowerCase();
      if (!formData.originMobileCode) {
        setErrors((prev) => ({
          ...prev,
          [name]: error_field_name + " is required",
        }));
        return;
      } else {
        setErrors((prev) => ({ ...prev, [name]: "" }));
        return;
      }
    }
  };

  const handleInputBlur = (e) => {
    const { name, value } = e.target;
    debugger;
    const trimValue = value.trimStart();
    const error_field_name = name.replace(/([A-Z])/g, " $1").toLowerCase();
    console.log(trimValue);
    if (!trimValue) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: t(error_field_name + ` is required`),
      }));
      return;
    }
    if (name == "dateOfBirth") {
      if (formData.dateOfBirth && isFutureDate(formData.dateOfBirth)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Date of Birth cannot be a future date",
        }));
      }
      return;
    }
    if (name == "entryDate") {
      if (formData.entryDate && isPastDate(formData.entryDate)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Entry Date cannot be a past date",
        }));
      }
      return;
    }

    if (name == "passportIssueDate") {
      if (
        formData.passportIssueDate &&
        isFutureDate(formData.passportIssueDate)
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Passport Issue Date cannot be a future date",
        }));
      }
      return;
    }
    if (name == "passportExpiryDate") {
      if (
        formData.passportExpiryDate &&
        isPastDate(formData.passportExpiryDate)
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Passport Expiry Date cannot be a past date",
        }));
      }
      return;
    }
  };

  useEffect(() => {
    const postvData = { organization_name: "Superjet" };
    if (vendorKey === "" || vendorKey === null || vendorKey === undefined) {
      fetch(base_url + "/create_organization", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postvData),
      })
        .then((response) => response.json())
        .then((data) => {
          setVendorKey(data.result[0].vendor_key);
          const element = document.querySelector(`[name="fullName"]`);
          if (element) {
            element.focus();
            element.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        })
        .catch((error) => {
          console.error("Error posting data:", error);
        });
    }
  }, [vendorKey]);

  useEffect(() => {
    var vkData = { vendor_key: vendorKey };
    if (vendorKey) {
      fetch(base_url + "/country", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(vkData),
      })
        .then((response) => response.json())
        .then((data) => {
          const filterCountry = data.result.filter((country)=> {
            return !(restrictedCountries.map(country=> country.toLowerCase()).includes(country.country.toLowerCase()))
          })
          setCountries(filterCountry);
        })
        .catch((error) => {
          console.error("Error fetching countries:", error);
        });
    }
  }, [vendorKey]);

  const isFutureDate = (dateString) => {
    const inputDate = new Date(dateString);
    const today = new Date();
    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return inputDate > today;
  };

  const isPastDate = (dateString) => {
    const inputDate = new Date(dateString);
    const today = new Date();
    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return inputDate < today;
  };

  const validateForm = () => {
    const newErrors = {}; // collect all field errors
    let firstInvalidField = null; // track first field for focusing

    const requiredFields = [
      "fullName",
      "nationality",
      "dateOfBirth",
      "gender",
      "passportNumber",
      "passportIssueDate",
      "passportExpiryDate",
      "countryOfIssue",
      "placeOfIssue",
      "email",
      "originMobileCode",
      "originMobile",
      "omanMobileCode",
      "omanMobile",
      "entryDate",
      "stayDuration",
      "visaType",
    ];

    // ✅ Loop through required fields
    for (let field of requiredFields) {
      if (!formData[field]) {
        newErrors[field] =
          field.replace(/([A-Z])/g, " $1").toLowerCase() + " " + "is required";

        // focus only the first invalid field
        if (!firstInvalidField) firstInvalidField = field;
      }
    }

    // ✅ Email pattern check
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (formData.email && !emailPattern.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
      if (!firstInvalidField) firstInvalidField = "email";
    }

    if (formData.dateOfBirth && isFutureDate(formData.dateOfBirth)) {
      newErrors.dateOfBirth = "Date of Birth cannot be a future date";
      if (!firstInvalidField) firstInvalidField = "dateOfBirth";
    }

    if (
      formData.passportIssueDate &&
      isFutureDate(formData.passportIssueDate)
    ) {
      newErrors.passportIssueDate =
        "Passport Issue Date cannot be a future date";
      if (!firstInvalidField) firstInvalidField = "passportIssueDate";
    }
    if (
      formData.passportExpiryDate &&
      isPastDate(formData.passportExpiryDate)
    ) {
      newErrors.passportExpiryDate =
        "Passport Expiry Date cannot be a past date";
      if (!firstInvalidField) firstInvalidField = "passportExpiryDate";
    }
    if (formData.entryDate && isPastDate(formData.entryDate)) {
      newErrors.entryDate = "Entry Date cannot be a past date";
      if (!firstInvalidField) firstInvalidField = "entryDate";
    }

    // ✅ Update state errors
    setErrors(newErrors);

    // ❌ If there are errors, focus the first invalid field
    if (Object.keys(newErrors).length > 0) {
      if (firstInvalidField) {
        if (firstInvalidField === "nationality" && nationalityRef.current) {
          nationalityRef.current.focus();
        } else if (
          firstInvalidField === "countryOfIssue" &&
          countryOfIssueRef.current
        ) {
          countryOfIssueRef.current.focus();
        } else if (
          firstInvalidField === "originMobileCode" &&
          originMobileCodeRef.current
        ) {
          originMobileCodeRef.current.focus();
        } else if (
          firstInvalidField === "omanMobileCode" &&
          omanMobileCodeRef.current
        ) {
          omanMobileCodeRef.current.focus();
        } else {
          const element = document.querySelector(
            `[name="${firstInvalidField}"]`
          );
          if (element) {
            element.focus();
            element.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }

      // ❌ Stop form submission
      return false;
    }

    // ✅ All good — clear errors and proceed
    setErrors({});
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setIsLoading(true);
    console.log(formData);

    try {
      sessionStorage.setItem("omanVisaFormData", JSON.stringify(formData));

      window.location.href = "/oman-visa-summary";
    } catch (error) {
      setIsLoading(false);
    }
  };

  // if (isSubmitted) {
  //     return (
  //         <Fragment>
  //             <div className="header_section1">
  //                 <Navbar />
  //                 <div className="container-fluid bg-breadcrumb">
  //                     <div className="container text-center py-5">
  //                         <h3 className="abt-txt my-5">{t("Oman Visa Application")}</h3>
  //                     </div>
  //                 </div>
  //             </div>

  //             <div className="features_section">
  //                 <div className="container mt-5">
  //                     <div className="row justify-content-center">
  //                         <div className="col-md-8 text-center">
  //                             <div className="alert alert-success p-4">
  //                                 <h4 className="text-success mb-3">✓ Form Submitted Successfully!</h4>
  //                                 <p>Your Oman visa application has been received. We will contact you shortly with further details.</p>
  //                                 <button
  //                                     className="btn btn-primary mt-3 me-3"
  //                                     onClick={() => window.location.href = '/travel-insurance'}
  //                                 >
  //                                     Buy Travel Insurance
  //                                 </button>
  //                                 <button
  //                                     className="btn btn-secondary mt-3"
  //                                     onClick={() => setIsSubmitted(false)}
  //                                 >
  //                                     Submit Another Application
  //                                 </button>
  //                             </div>
  //                         </div>
  //                     </div>
  //                 </div>
  //             </div>
  //             <Footer />
  //         </Fragment>
  //     );
  // }

  return (
    <Fragment>
      <div className="header_section1">
        <Navbar />
        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">{t("Oman Visa Application")}</h3>
          </div>
        </div>
      </div>

      <div className="features_section">
        <div className="container mt-5">
          <div className="row justify-content-center">
               
            <div className="col-md-10"  style={{ textAlign: lnstr == "ar" ? "right" : "" }} >
              {/* Form */}
              <div className="card mb-4">
                 <div className="card-header" style={{backgroundColor:"rgba(35, 186, 220, 0.12)"}}> 
                  <h4 className="mb-0">{t("Visa Service Notice")}</h4>
                </div>
                <div className="card-body">
                      
                         <p>
                          {lnstr=="ar"?
                          "خدمات التأشيرات لسلطنة عمان غير متاحة حاليًا لمواطني الدول التالية:"
                        :
                         <>
                      Visa services for{" "}
                      <span style={{ fontWeight: "600" }}>
                        Sultanate of Oman
                      </span>{" "}
                      are currently unavailable for citizens of the following countries:
                    </>
                        }</p>
                      
                       <ul className="d-flex ml-3 flex-wrap mb-3">
                          {restrictedCountries.map((country, index) => (
                            <div key={index} className="country-li" >
                              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="currentColor" class="bi bi-circle-fill" viewBox="0 0 16 16">
                                <circle cx="8" cy="8" r="8"/>
                              </svg> &nbsp;&nbsp;
                              {t(country)}
                            </div>
                          ))}
                        </ul>
                        <p>
                          {
                           lnstr=="ar"?
                           "إذا كانت جنسيتك مدرجة في القائمة أعلاه، فنأسف لإبلاغك أننا غير قادرين على معالجة طلب تأشيرتك في الوقت الحالي."
                           :
                         <> If your nationality is <span style={{fontWeight:"600"}}>listed above</span>, we regret to inform
                          you that we are unable to process your visa application at this time.
                          </>
                        }
                        </p>
                  </div>
                </div>
              <div
                className="card"
              >
                <div className="card-header">
                  <h4 className="mb-0">{t("Oman Visa Application Form")}</h4>
                </div>
                <div className="card-body">
                  <form>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">
                          {t("Full Name (as per passport)")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.fullName ? "is-invalid" : ""
                          }`}
                          name="fullName"
                          value={formData.fullName}
                          onChange={handleInputChange}
                          onBlur={handleInputBlur}
                        />
                        {errors.fullName && (
                          <div className="invalid-feedback">
                            {t(errors.fullName)}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">
                          {t("Nationality")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>

                        <div className={errors.nationality ? "is-invalid" : ""}>
                          <ReactSelect
                            ref={nationalityRef}
                            options={countryList?.map((country) => ({
                              value: country.id,
                              label:
                                lnstr === "en"
                                  ? country.country
                                  : t(country.country),
                            }))}
                            value={countryList
                              ?.map((country) => ({
                                value: country.id,
                                label:
                                  lnstr === "en"
                                    ? country.country
                                    : t(country.country),
                              }))
                              .find(
                                (option) =>
                                  option.value === formData.nationalityId
                              )}
                            onChange={(selectedOption) => {
                              handleInputChange({
                                target: {
                                  name: "nationality",
                                  value: selectedOption?.label || "",
                                  country_id: selectedOption?.value || "",
                                },
                              });
                            }}
                            onBlur={(selectedOption) => {
                              handleSelectBlur({
                                target: {
                                  name: "nationality",
                                  value: selectedOption?.label || "",
                                  country_id: selectedOption?.value || "",
                                },
                              });
                            }} // ✅ triggers validation on blur
                            placeholder={t(`Select nationality`)}
                            isSearchable
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                borderColor: errors.nationality
                                  ? "#dc3545" // 🔴 red border for invalid
                                  : state.isFocused
                                  ? "#86b7fe" // blue border when focused
                                  : "#ced4da", // normal Bootstrap border
                                boxShadow: errors.nationality
                                  ? state.isFocused
                                    ? "0 0 0 0.25rem rgba(220, 53, 69, 0.25)"
                                    : "none" // red glow
                                  : state.isFocused
                                  ? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)" // blue glow on focus
                                  : "none",
                                "&:hover": {
                                  borderColor: errors.nationality
                                    ? "#dc3545"
                                    : "#86b7fe",
                                },
                              }),
                              menu: (base) => ({
                                ...base,
                                zIndex: 9999, // ensures dropdown isn’t hidden
                              }),
                            }}
                            //   classNamePrefix={errors.nationality ? "react-select is-invalid" : "react-select"}
                          />
                        </div>

                        {errors.nationality && (
                          <div className="invalid-feedback d-block">
                            {t(errors.nationality)}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">
                          {t("Date of Birth")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="date"
                          className={`form-control ${
                            errors?.dateOfBirth ? "is-invalid" : ""
                          }`}
                          name="dateOfBirth"
                          max={new Date().toISOString().split('T')[0]}
                          value={formData?.dateOfBirth}
                          onChange={handleInputChange}
                          onBlur={handleInputBlur}
                        />
                        {errors.dateOfBirth && (
                          <div className="invalid-feedback">
                            {t(errors.dateOfBirth)}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">
                          {t("Gender")} <span style={{ color: "red" }}>*</span>
                        </label>
                        <select
                          className={`form-control ${
                            errors?.gender ? "is-invalid" : ""
                          }`}
                          name="gender"
                          value={formData.gender}
                          onChange={handleInputChange}
                          onBlur={handleInputBlur}
                        >
                          <option value="">{t("Select Gender")}</option>
                          <option value="Male">{t("Male")}</option>
                          <option value="Female">{t("Female")}</option>
                        </select>
                        {errors.gender && (
                          <div className="invalid-feedback">
                            {t(errors.gender)}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">
                          {t("Passport Number")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors?.passportNumber ? "is-invalid" : ""
                          }`}
                          name="passportNumber"
                          value={formData.passportNumber}
                          onChange={handleInputChange}
                          onBlur={handleInputBlur}
                        />
                        {errors.passportNumber && (
                          <div className="invalid-feedback">
                            {t(errors.passportNumber)}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">
                          {t("Passport Issue Date")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="date"
                          className={`form-control ${
                            errors?.passportIssueDate ? "is-invalid" : ""
                          }`}
                          name="passportIssueDate"
                          max={new Date().toISOString().split('T')[0]}
                          value={formData.passportIssueDate}
                          onChange={handleInputChange}
                          onBlur={handleInputBlur}
                        />
                        {errors.passportIssueDate && (
                          <div className="invalid-feedback">
                            {t(errors.passportIssueDate)}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">
                          {t("Passport Expiry Date")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="date"
                          className={`form-control ${
                            errors?.passportExpiryDate ? "is-invalid" : ""
                          }`}
                          name="passportExpiryDate"
                          min={new Date().toISOString().split('T')[0]}
                          value={formData.passportExpiryDate}
                          onChange={handleInputChange}
                          onBlur={handleInputBlur}
                        />
                        {errors.passportExpiryDate && (
                          <div className="invalid-feedback">
                            {t(errors.passportExpiryDate)}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">
                          {t("Country of Issue")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className={errors.nationality ? "is-invalid" : ""}>
                          <ReactSelect
                            ref={countryOfIssueRef}
                            options={countryList?.map((country) => ({
                              value: country.id,
                              label:
                                lnstr === "en"
                                  ? country.country
                                  : t(country.country),
                            }))}
                            value={countryList
                              ?.map((country) => ({
                                value: country.id,
                                label:
                                  lnstr === "en"
                                    ? country.country
                                    : t(country.country),
                              }))
                              .find(
                                (option) =>
                                  option.value === formData.countryOfIssueId
                              )}
                            onChange={(selectedOption) => {
                              handleInputChange({
                                target: {
                                  name: "countryOfIssue",
                                  value: selectedOption?.label || "",
                                  country_id: selectedOption?.value || "",
                                },
                              });
                            }}
                            onBlur={(selectedOption) => {
                              handleSelectBlur({
                                target: {
                                  name: "countryOfIssue",
                                  value: selectedOption?.label || "",
                                  country_id: selectedOption?.value || "",
                                },
                              });
                            }} // ✅ triggers validation on blur
                            placeholder={t(`Select country`)}
                            isSearchable
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                borderColor: errors.countryOfIssue
                                  ? "#dc3545" // 🔴 red border for invalid
                                  : state.isFocused
                                  ? "#86b7fe" // blue border when focused
                                  : "#ced4da", // normal Bootstrap border
                                boxShadow: errors.countryOfIssue
                                  ? state.isFocused
                                    ? "0 0 0 0.25rem rgba(220, 53, 69, 0.25)"
                                    : "none" // red glow
                                  : state.isFocused
                                  ? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)" // blue glow on focus
                                  : "none",
                                "&:hover": {
                                  borderColor: errors.countryOfIssue
                                    ? "#dc3545"
                                    : "#86b7fe",
                                },
                              }),
                              menu: (base) => ({
                                ...base,
                                zIndex: 9999, // ensures dropdown isn’t hidden
                              }),
                            }}
                          />
                        </div>

                        {errors.countryOfIssue && (
                          <div className="invalid-feedback d-block">
                            {t(errors.countryOfIssue)}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">
                          {t("Place of Issue")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors?.placeOfIssue ? "is-invalid" : ""
                          }`}
                          name="placeOfIssue"
                          value={formData.placeOfIssue}
                          onChange={handleInputChange}
                          onBlur={handleInputBlur}
                        />
                        {errors.placeOfIssue && (
                          <div className="invalid-feedback">
                            {t(errors.placeOfIssue)}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">
                          {t("Email Address")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors?.email ? "is-invalid" : ""
                          }`}
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          onBlur={handleInputBlur}
                        />
                        {errors.email && (
                          <div className="invalid-feedback">
                            {t(errors.email)}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">
                          {t("Country of Origin Mobile Number")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>

                        <div className="w-100 d-flex">
                          {/* ReactSelect for country code */}
                          <ReactSelect
                            ref={originMobileCodeRef}
                            options={countryList?.map((country) => ({
                              value: country.id,
                              label: country.country_code,
                            }))}
                            value={countryList
                              ?.map((country) => ({
                                value: country.id,
                                label: country.country_code,
                              }))
                              .find(
                                (option) =>
                                  option.label === formData?.originMobileCode
                              )}
                            onChange={(selectedOption) => {
                              handleInputChange({
                                target: {
                                  name: "originMobileCode",
                                  value: selectedOption?.label || "",
                                },
                              });
                            }}
                            onBlur={(selectedOption) => {
                              handleSelectBlur({
                                target: {
                                  name: "originMobileCode",
                                  value: selectedOption?.label || "",
                                },
                              });
                            }} // ✅ triggers validation on blur
                            placeholder={t(`code`)}
                            isSearchable
                            className="w-25"
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                borderColor: errors.originMobileCode
                                  ? "#dc3545" // 🔴 red border for invalid
                                  : state.isFocused
                                  ? "#86b7fe" // 🔵 blue border when focused
                                  : "#ced4da", // default border
                                boxShadow: errors.originMobileCode
                                  ? state.isFocused
                                    ? "0 0 0 0.25rem rgba(220, 53, 69, 0.25)" // red glow
                                    : "none"
                                  : state.isFocused
                                  ? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)" // blue glow
                                  : "none",
                                "&:hover": {
                                  borderColor: errors.originMobileCode
                                    ? "#dc3545"
                                    : "#86b7fe",
                                },
                                borderRadius: "0.375rem 0 0 0.375rem",
                              }),
                              menu: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                            }}
                          />

                          {/* Input for mobile number */}
                          <input
                            type="tel"
                            className={`form-control ${
                              errors?.originMobile ? "is-invalid" : ""
                            }`}
                            style={{ width: "75%" }}
                            name="originMobile"
                            value={formData.originMobile}
                            onChange={handleInputChange}
                            onBlur={handleInputBlur}
                            placeholder=""
                          />
                        </div>

                        {/* Validation Message */}
                        {errors.originMobile && (
                          <div className="invalid-feedback d-block">
                            {t(errors.originMobile)}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label">
                          {t("Mobile Number in Oman")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>

                        <div className="w-100 d-flex">
                          {/* ReactSelect for Oman country code */}
                          <ReactSelect
                            ref={omanMobileCodeRef}
                            options={countryList?.map((country) => ({
                              value: country.id,
                              label: country.country_code,
                            }))}
                            value={countryList
                              ?.map((country) => ({
                                value: country.id,
                                label: country.country_code,
                              }))
                              .find(
                                (option) =>
                                  option.label === formData?.omanMobileCode
                              )}
                            onChange={(selectedOption) => {
                              handleInputChange({
                                target: {
                                  name: "omanMobileCode",
                                  value: selectedOption?.label || "",
                                },
                              });
                            }}
                            onBlur={(selectedOption) => {
                              handleSelectBlur({
                                target: {
                                  name: "omanMobileCode",
                                  value: selectedOption?.label || "",
                                },
                              });
                            }} // ✅ triggers validation on blur
                            placeholder={t(`code`)}
                            isSearchable
                            className="w-25"
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                borderColor: errors.omanMobileCode
                                  ? "#dc3545" // 🔴 red border for invalid
                                  : state.isFocused
                                  ? "#86b7fe" // 🔵 blue border when focused
                                  : "#ced4da", // normal border
                                boxShadow: errors.omanMobileCode
                                  ? state.isFocused
                                    ? "0 0 0 0.25rem rgba(220, 53, 69, 0.25)" // red glow
                                    : "none"
                                  : state.isFocused
                                  ? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)" // blue glow
                                  : "none",
                                "&:hover": {
                                  borderColor: errors.omanMobileCode
                                    ? "#dc3545"
                                    : "#86b7fe",
                                },
                                borderRadius: "0.375rem 0 0 0.375rem",
                              }),
                              menu: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                            }}
                          />

                          {/* Input for mobile number */}
                          <input
                            type="tel"
                            className={`form-control ${
                              errors?.omanMobile ? "is-invalid" : ""
                            }`}
                            style={{ width: "75%" }}
                            name="omanMobile"
                            value={formData.omanMobile}
                            onChange={handleInputChange}
                            onBlur={handleInputBlur}
                            placeholder=""
                          />
                        </div>

                        {/* Validation Message */}
                        {errors.omanMobile && (
                          <div className="invalid-feedback d-block">
                            {t(errors.omanMobile)}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">
                          {t("Intended Entry Date")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="date"
                          className={`form-control ${
                            errors?.entryDate ? "is-invalid" : ""
                          }`}
                          name="entryDate"
                          value={formData.entryDate}
                          min={new Date().toISOString().split('T')[0]}
                          onChange={handleInputChange}
                          onBlur={handleInputBlur}
                        />
                        {errors.entryDate && (
                          <div className="invalid-feedback">
                            {t(errors.entryDate)}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">
                          {t("Duration of Stay")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors?.stayDuration ? "is-invalid" : ""
                          }`}
                          name="stayDuration"
                          value={formData.stayDuration}
                          onChange={handleInputChange}
                          onBlur={handleInputBlur}
                          placeholder="e.g., 7 days"
                        />
                        {errors.stayDuration && (
                          <div className="invalid-feedback">
                            {t(errors.stayDuration)}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">
                          {t("Visa Type")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <select
                          className={`form-control ${
                            errors?.visaType ? "is-invalid" : ""
                          }`}
                          name="visaType"
                          value={formData.visaType}
                          onChange={handleInputChange}
                          onBlur={handleInputBlur}
                        >
                          <option value="">{t("Select Visa Type")}</option>
                          <option value="Tourist Visa">
                            {t("Tourist Visa")}
                          </option>
                          <option value="Express Visa">
                            {t("Express Visa")}
                          </option>
                          <option value="GCC Residence Tourist Visa">
                            {t("GCC Residence Tourist Visa")}
                          </option>
                        </select>
                        {errors.visaType && (
                          <div className="invalid-feedback">
                            {t(errors.visaType)}
                          </div>
                        )}
                      </div>
                    </div>

                    <hr className="my-4" />

                    <div className="text-center mt-4">
                      <button
                        type="submit"
                        className="btn btn-primary btn-lg px-5"
                        onClick={handleSubmit}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          "Loading..."
                        ) : (
                          <>
                            {t("Next Page")}&nbsp;&nbsp;
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              class="bi bi-arrow-right"
                              viewBox="0 0 16 16"
                              style={{ position: "relative", top: "4px" }}
                            >
                              <path
                                fill-rule="evenodd"
                                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                              />
                            </svg>
                          </>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <ToastContainer position="top-right" autoClose={5000} />
    </Fragment>
  );
};

export default OmanVisaForm;
